import { ExclamationCircleFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { WarningColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconWarningCircleWarning: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return (
        <ExclamationCircleFilled
            {...props}
            type="warning"
            style={{ ...props.style, color: WarningColor }}
        />
    );
};
